import * as types from './constants.jsx';


export function searchCompanies() {
    return {
        type: types.SEARCH_COMPANY,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/residues-search/`,
                method: "get"
            }
        }
    };
}

export function getCompaniesGoods(id, articleNumber = null) {
    return {
        type: types.GET_COMPANIES_GOODS,
        payload: {
            client: 'default',
            request: {
                url: '/admin/japarts/residues-products/',
                method: "get",
                params: {
                    producer_id: id,
                    article_number: articleNumber || undefined
                }
            }
        }
    };
}

export function postNewResidue(data) {
    return {
        type: types.POST_NEW_RESIDUE,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/residues/`,
                method: "post",
                data
            }
        }
    };
}
export function getAllResidues(params) {
    return {
        type: types.GET_ALL_RESIDUES,
        payload: {
            client: 'default',
            request: {
                url: `/admin/japarts/residues/`,
                method: "get",
                params
            }
        }
    };
}

export function getResidueById(id) {
    return {
        type: types.GET_RESIDUE_BY_ID,
        payload: {
            client: 'default',
            request: {
                url: `/1c/residue/${id}/`,
                method: "get"
            }
        }
    };
}